import React from "react";
import { DetailsBasePage } from "./DetailsBasePage.tsx";
import { Link, Stack, Typography } from "@mui/material";

const links = [
  { name: "LinkedIn", url: "https://www.linkedin.com/in/tholt1220/" },
  { name: "GitHub", url: "https://github.com/tholt1220" },
  { name: "Email", url: "mailto:trevholt1220@gmail.com" },
  { name: "Instagram", url: "https://www.instagram.com/tholt1220/" },
];
export const ContactDetails = () => {
  return (
    <DetailsBasePage title="Contact">
      <Stack spacing={5}>
        <Typography variant="h6" component={"em"}>
          Come say hello ={")"}
        </Typography>

        {links.map(({ name, url }, idx) => (
          <Link
            href={url}
            key={name}
            sx={(theme) => ({
              paddingLeft: idx * 10,
              [theme.breakpoints.down("md")]: {
                paddingLeft: idx * 5,
              },
            })}
          >
            {name}
          </Link>
        ))}
      </Stack>
    </DetailsBasePage>
  );
};
